<template>
    <main-layout>
        <div class="page-head" slot="header">
            <div><div class="page-kicker">Tenancies</div><h2>Owners</h2></div>
        </div>
        <div class="list-tabs" role="tablist" aria-label="Owners">
            <router-link role="tab" :aria-selected="String($route.path === '/buildium/rental-owners')" tag="button"
                         :class="{on: $route.path === '/buildium/rental-owners'}" to="/buildium/rental-owners">Rental owners</router-link>
            <router-link role="tab" :aria-selected="String($route.path === '/buildium/association-owners')" tag="button"
                         :class="{on: $route.path === '/buildium/association-owners'}" to="/buildium/association-owners">Association owners</router-link>
        </div>
        <div class="list-filters">
            <el-input v-model="params.q" class="list-search" clearable prefix-icon="el-icon-search"
                      placeholder="Name, company or email" aria-label="Search owners"/>
        </div>
        <section class="page-section" v-loading="loading">
            <el-table :data="dataList" @selection-change="onSelectionChange">
                <el-table-column width="45" type="selection"/>
                <el-table-column prop="Id" label="ID" width="100"/>
                <el-table-column prop="FullName" label="Name" width="200"/>
                <el-table-column prop="Email" label="Email"/>
                <el-table-column prop="AlternateEmail" label="Alternate Email"/>
                <el-table-column label="PhoneNumber">
                    <template slot-scope="scope">
                        <div v-for="phone in scope.row.PhoneNumbers||[]">{{ phone.Number }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="Status" label="Address">
                    <template slot-scope="scope">
                        <span>{{ getAddressString(scope.row.PrimaryAddress) }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="table-edit-footer">
                <div class="table-actions">
                    <el-select size="small" v-model="bulkAction">
                        <el-option label="Delete" value="delete"></el-option>
                        <el-option label="Send File" value="sendfile"></el-option>
                    </el-select>
                    <el-button type="primary" size="small" :disabled="!selectionIds.length" @click="onBulkAction">{{
                            $t('common.apply')
                        }}
                    </el-button>
                </div>
                <div class="flex"></div>
                <el-pagination
                    background
                    layout="prev, pager, next, total"
                    :total="total"
                    :page-size="pageSize"
                    :current-page="page"
                    @current-change="onPageChange"
                />
            </div>
        </section>
        <dialog-send-file ref="sendFile" @send="batchSendFile"/>
    </main-layout>
</template>

<script>
import Pagination from "../mixins/Pagination";
import ApiService from "../utils/ApiService";
import DialogSendFile from "../components/DialogSendFile.vue";

export default {
    name: "AssociationOwners",
    components: {DialogSendFile},
    mixins: [Pagination],
    data() {
        return {
            bulkAction: '',
            params: {q: ''},
            autoSearch: true,
        }
    },
    methods: {
        listApi() {
            return '/buildium/associations/owners'
        },
        listParams() {
            return this.params;
        },
        batchDelete() {
            this.$confirm(this.$t('common.delete_tips'), this.$t('common.delete_confirm'), {
                type: 'warning'
            }).then(() => {
                this.loading = true;
                let ids = this.selectionIds.map((d) => d.Id);
                ApiService.delete('/buildium/associations/owners/batch', {data: {ids}}).then(() => {
                    this.fetchList();
                    this.$message.success('Owners Deleted');
                }).catch(reason => {
                    this.$message.error(reason.message);
                }).finally(() => {
                    this.loading = false;
                });
            });
        },
        batchSendFile(data) {
            let ids = this.selectionIds.map((d) => d.Id);
            this.loading = true;
            ApiService.post('/buildium/associations/owners/sendfiles', {
                ids,
                ...data
            }).then(() => {
                this.selectionIds = [];
                this.$message.success('Added to queue successfully');
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {
                this.loading = false;
            });
        },
        getAddressString(address) {
            return `${address.AddressLine1}, ${address.PostalCode}, ${address.City}, ${address.State}`;
        },
        onBulkAction() {
            switch (this.bulkAction) {
                case 'delete':
                    this.batchDelete();
                    break;
                case 'sendfile':
                    this.$refs.sendFile.open();
                    break;
            }
        }
    },
    watch: {
        '$route.query.q'(value) {
            this.params.q = value || '';
        },
    },
    mounted() {
        if (this.$route.query.q) {
            this.params.q = this.$route.query.q;
        }
        this.fetchList();
    }
}
</script>

<style scoped>

</style>